import * as TK from 'components/PDP/Details/components/Marketplace/components/MarketplaceProductShipping/translations/marketplace-product-shipping.locale.constants';

export const marketPlaceShippingCommonLocale = {
  [TK.MARKETPLACE_FREE_SHIPPING]:
    'FREE shipping on {{productBrandName}} orders over {{minimumShippingAmount}}.',
  [TK.MARKETPLACE_RESTRICTED_STATE]: `Cannot ship to {{state}}.`,
  [TK.MARKETPLACE_MULTIPLE_RESTRICTED_STATES]:
    'Cannot ship to {{allButLastStates}} and {{lastState}}.',
};
